export default {
      id: "ar-annuaire-usage",
      viewBox: "0 0 125 125",
      url: "../dist/images/" + "sprite.svg#ar-annuaire-usage",
      toString: function () {
        return this.url;
      }
    }